module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "heading": (_vm.isAdd ? 'Add' : (_vm.isView ? 'View' : 'Edit')) + ' Checklist' + (_vm.isAdd ? '' : _vm.formData.name + (_vm.formData.category ? ' (' + _vm.formData.category + ')' : '')),
      "button-style": _vm.isAdd ? 'warning' : 'text',
      "round": "",
      "button-size": _vm.isAdd ? 'mini' : 'text',
      "button-text": _vm.isAdd ? 'Add' : (_vm.isView ? 'View' : 'Edit'),
      "button-icon": _vm.isAdd ? 'fa fa-plus' : (_vm.isView ? 'fa fa-eye' : 'fa fa-edit'),
      "show-save": !_vm.isView,
      "disableButton": !_vm.isView && !_vm.canAccess('maintenance')
    },
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "11em"
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Checklist"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [(_vm.editing) ? _c('select-input', {
    attrs: {
      "label": "",
      "placeholder": "Select Category...",
      "list": _vm.categoryOption,
      "filterable": "",
      "create": "",
      "disabled": !_vm.editing || !_vm.isSiteManager
    },
    model: {
      value: (_vm.formData.category),
      callback: function($$v) {
        _vm.$set(_vm.formData, "category", $$v)
      },
      expression: "formData.category"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [(_vm.editing) ? _c('text-input', {
    attrs: {
      "label": "",
      "placeholder": "Checklist Name...",
      "disabled": !_vm.editing || !_vm.isSiteManager
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [(_vm.editing || _vm.formData.photoRequired) ? _c('check-box', {
    attrs: {
      "disabled": !_vm.editing || !_vm.isSiteManager
    },
    model: {
      value: (_vm.formData.photoRequired),
      callback: function($$v) {
        _vm.$set(_vm.formData, "photoRequired", $$v)
      },
      expression: "formData.photoRequired"
    }
  }, [_vm._v("\n                Photo Required "), _c('b', {
    staticClass: "success-text",
    class: _vm.formData.photoRequired ? 'fa fa-camera' : ''
  })]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isSite) ? _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('select-input', {
    attrs: {
      "placeholder": "Select Status...",
      "list": _vm.ticketOptions,
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", $$v)
      },
      expression: "formData.status"
    }
  })], 1), _vm._v(" "), (_vm.formData.status === 'Finished') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-rate', {
    attrs: {
      "min": 1,
      "max": _vm.formData.gradingMax,
      "colors": ['#99A9BF', '#F7BA2A', '#FF9900'],
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.formData.grading),
      callback: function($$v) {
        _vm.$set(_vm.formData, "grading", $$v)
      },
      expression: "formData.grading"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.notesToWorkers || _vm.editing) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('html-input', {
    attrs: {
      "label": "Notes To Workers",
      "disabled": !_vm.editing || _vm.isTelco()
    },
    model: {
      value: (_vm.formData.notesToWorkers),
      callback: function($$v) {
        _vm.$set(_vm.formData, "notesToWorkers", $$v)
      },
      expression: "formData.notesToWorkers"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.formData.photoRequired && !_vm.isAdd && _vm.isSite) ? _c('el-tab-pane', {
    attrs: {
      "label": "Upload Photos",
      "lazy": ""
    }
  }, [_c('el-row', {
    staticClass: "padded",
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('files-panel', {
    attrs: {
      "title": "Before",
      "max-files": 1,
      "type": "site",
      "id": _vm.rowData.site_id,
      "process": "workflow-before",
      "process-id": _vm.formData.id,
      "disabled": _vm.isView,
      "hide-carousel": ""
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('files-panel', {
    attrs: {
      "title": "After",
      "max-files": 1,
      "type": "site",
      "id": _vm.rowData.site_id,
      "process": "workflow-after",
      "process-id": _vm.formData.id,
      "disabled": _vm.isView,
      "hide-carousel": ""
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Service Level Agreement (SLA)"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [(_vm.editing) ? _c('integer-input', {
    attrs: {
      "label": "Workforce Estimated",
      "placeholder": "Workforce (est.)",
      "disabled": !_vm.editing || !_vm.isSiteManager
    },
    model: {
      value: (_vm.formData.workforceReq),
      callback: function($$v) {
        _vm.$set(_vm.formData, "workforceReq", $$v)
      },
      expression: "formData.workforceReq"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Setup Task Time (est.)",
      "placeholder": "Setup Task Time",
      "suffix": _vm.disabled ? _vm.formData.setupTimeUnits : '',
      "prefix": "fa fa-clock text-muted",
      "is-prefix-icon": true,
      "disabled": !_vm.editing || !_vm.isSiteManager
    },
    model: {
      value: (_vm.formData.setupTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "setupTime", $$v)
      },
      expression: "formData.setupTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('select-input', {
    attrs: {
      "label": "Setup Time Units",
      "list": _vm.unitsOption,
      "disabled": !_vm.editing || !_vm.isSiteManager
    },
    model: {
      value: (_vm.formData.setupTimeUnits),
      callback: function($$v) {
        _vm.$set(_vm.formData, "setupTimeUnits", $$v)
      },
      expression: "formData.setupTimeUnits"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Task Time (est.)",
      "placeholder": "Task Time",
      "suffix": _vm.disabled ? _vm.formData.taskUnits : '',
      "prefix": "fa fa-clock text-muted",
      "is-prefix-icon": true,
      "disabled": !_vm.editing || !_vm.isSiteManager
    },
    model: {
      value: (_vm.formData.taskTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "taskTime", $$v)
      },
      expression: "formData.taskTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('select-input', {
    attrs: {
      "label": "Time Units",
      "list": _vm.unitsOption,
      "disabled": !_vm.editing || !_vm.isSiteManager
    },
    model: {
      value: (_vm.formData.taskUnits),
      callback: function($$v) {
        _vm.$set(_vm.formData, "taskUnits", $$v)
      },
      expression: "formData.taskUnits"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.canAccess('maintenance|project|management') && (_vm.formData.remarks || (_vm.editing && _vm.isSiteManager))) ? _c('el-tab-pane', {
    attrs: {
      "label": "Remarks"
    }
  }, [(_vm.formData.remarks || _vm.editing) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('html-input', {
    attrs: {
      "label": "Remarks",
      "disabled": !_vm.editing || !_vm.isSiteManager
    },
    model: {
      value: (_vm.formData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remarks", $$v)
      },
      expression: "formData.remarks"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fbf04cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/checklist/EditChecklist.vue
// module id = 1664
// module chunks = 0